"use client";

import React from "react";
import { Mail, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { ScrollArea } from "@/components/ui/scroll-area";
const tocItems = [{
  id: "widerrufsrecht",
  title: "1. Widerrufsrecht"
}, {
  id: "folgen-widerruf",
  title: "2. Folgen des Widerrufs"
}, {
  id: "erloeschen",
  title: "3. Vorzeitiges Erlöschen"
}, {
  id: "muster-formular",
  title: "4. Muster-Widerrufsformular"
}, {
  id: "kontakt",
  title: "5. Kontakt für Widerruf"
}];
export default function Widerrufsbelehrung() {
  return <section data-section-id="260297" id="widerrufsbelehrung" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          
          {}
          <div className="hidden lg:block lg:col-span-3">
            <div className="sticky top-24">
              <h4 className="font-default text-lg font-semibold text-primary mb-4">
                Inhaltsverzeichnis
              </h4>
              <ScrollArea className="h-[calc(100vh-12rem)] pr-4">
                <nav className="flex flex-col space-y-3">
                  {tocItems.map((item, i) => <div key={item.id} data-index={i}>
                      <Link to={`#${item.id}`} className="text-sm text-muted-foreground hover:text-primary transition-colors block py-1 font-default">
                        {item.title}
                      </Link>
                    </div>)}
                </nav>
              </ScrollArea>
            </div>
          </div>

          {}
          <div className="col-span-1 lg:col-span-9 privacy-content">
            <div className="mb-12">
              <h1 className="font-default text-4xl md:text-5xl font-bold text-primary mb-4 tracking-tight">
                Widerrufsbelehrung
              </h1>
              <p className="text-muted-foreground text-lg font-default">
                Stand: 24. Mai 2024
              </p>
            </div>

            <div className="space-y-12 text-foreground/90 font-default leading-relaxed">
              
              {}
              <div id="widerrufsrecht" className="scroll-mt-24">
                <h2 className="font-default text-2xl md:text-3xl font-semibold text-primary mb-4">
                  1. Widerrufsrecht
                </h2>
                <p className="mb-4">
                  Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses. Um Ihr Widerrufsrecht auszuüben, müssen Sie uns mittels einer eindeutigen Erklärung über Ihren Entschluss informieren.
                </p>
                <p>
                  Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden. Dies gilt für alle Dienstleistungen und digitalen Inhalte unseres Bildungszentrums.
                </p>
              </div>

              <Separator className="bg-border" />

              {}
              <div id="folgen-widerruf" className="scroll-mt-24">
                <h2 className="font-default text-2xl md:text-3xl font-semibold text-primary mb-6">
                  2. Folgen des Widerrufs
                </h2>
                
                <h3 className="font-default text-xl font-medium text-primary mb-3">
                  2.1 Rückzahlung von Zahlungen
                </h3>
                <p className="mb-4">
                  Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, einschließlich der Lieferkosten, unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf bei uns eingegangen ist.
                </p>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                  <li><strong>Rückzahlungsmethode:</strong> Wir verwenden dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben.</li>
                  <li><strong>Entgelte:</strong> In keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.</li>
                  <li><strong>Dienstleistungen:</strong> Haben Sie verlangt, dass die Dienstleistungen während der Widerrufsfrist beginnen sollen, so haben Sie uns einen angemessenen Betrag zu zahlen.</li>
                </ul>

                <h3 className="font-default text-xl font-medium text-primary mb-3">
                  2.2 Wertersatz bei Dienstleistungen
                </h3>
                <p className="mb-4">
                  Der Betrag entspricht dem Anteil der bis zu dem Zeitpunkt, zu dem Sie uns von der Ausübung des Widerrufsrechts hinsichtlich dieses Vertrags unterrichten, bereits erbrachten Dienstleistungen im Vergleich zum Gesamtumfang der im Vertrag vorgesehenen Dienstleistungen.
                </p>
              </div>

              <Separator className="bg-border" />

              {}
              <div id="erloeschen" className="scroll-mt-24">
                <h2 className="font-default text-2xl md:text-3xl font-semibold text-primary mb-4">
                  3. Vorzeitiges Erlöschen
                </h2>
                <p className="mb-4">
                  Das Widerrufsrecht erlischt bei einem Vertrag zur Erbringung von Dienstleistungen auch dann, wenn wir die Dienstleistung vollständig erbracht haben und mit der Ausführung der Dienstleistung erst begonnen haben, nachdem Sie dazu Ihre ausdrückliche Zustimmung gegeben haben.
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Zustimmung zum Beginn der Ausführung vor Ablauf der Widerrufsfrist.</li>
                  <li>Kenntnisnahme über den Verlust des Widerrufsrechts bei vollständiger Vertragserfüllung.</li>
                  <li>Bereitstellung von digitalen Inhalten (z.B. Online-Kursmaterialien).</li>
                </ul>
              </div>

              <Separator className="bg-border" />

              {}
              <div id="muster-formular" className="scroll-mt-24">
                <h2 className="font-default text-2xl md:text-3xl font-semibold text-primary mb-4">
                  4. Muster-Widerrufsformular
                </h2>
                <p className="mb-4">
                  (Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie es zurück.)
                </p>
                <div className="bg-secondary p-6 rounded-lg border border-border italic text-sm space-y-2">
                  <p>— An [Name/Unternehmen, Adresse, E-Mail-Adresse einfügen]:</p>
                  <p>— Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den Kauf der folgenden Waren (*)/die Erbringung der folgenden Dienstleistung (*)</p>
                  <p>— Bestellt am (*)/erhalten am (*)</p>
                  <p>— Name des/der Verbraucher(s)</p>
                  <p>— Anschrift des/der Verbraucher(s)</p>
                  <p>— Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier)</p>
                  <p>— Datum</p>
                  <p>(*) Unzutreffendes streichen.</p>
                </div>
              </div>

              <Separator className="bg-border" />

              {}
              <div id="kontakt" className="scroll-mt-24 bg-card p-8 rounded-lg border border-border shadow-md">
                <h2 className="font-default text-2xl md:text-3xl font-semibold text-primary mb-6">
                  5. Kontakt für Widerruf
                </h2>
                <p className="mb-6">
                  Bitte richten Sie Ihren Widerruf schriftlich per Post oder E-Mail an unsere Verwaltung. Wir bestätigen den Eingang Ihres Widerrufs unverzüglich.
                </p>
                
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <Mail className="w-6 h-6 text-primary shrink-0 mt-0.5" />
                    <div>
                      <p className="font-default font-medium text-foreground">E-Mail Adresse</p>
                      <Link to="mailto:verwaltung@bildungszentrum-campus.de" className="text-primary hover:underline font-default">
                        verwaltung@bildungszentrum-campus.de
                      </Link>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-3">
                    <MapPin className="w-6 h-6 text-primary shrink-0 mt-0.5" />
                    <div>
                      <p className="font-default font-medium text-foreground">Postanschrift</p>
                      <address className="not-italic text-muted-foreground font-default">
                        Bildungszentrum Campus Nord<br />
                        Akademiestraße 45<br />
                        10117 Berlin<br />
                        Deutschland
                      </address>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>;
}